import React from 'react';
import SummaryItem from './SummaryItem';
import type { OrderSummaryData } from '../../../types';

interface ProductsListProps {
  products: OrderSummaryData['products'];
}

export const ProductsList: React.FC<ProductsListProps> = ({ products }) => {
  return (
    <div className="pr-2 space-y-1 divide-y divide-gray-100 dark:divide-gray-700">
      {(products ?? []).map((item, index) => {
        // Cria uma chave única baseada no ID, propriedades e índice
        const propertiesKey = item.properties 
          ? Object.entries(item.properties).map(([k, v]) => `${k}:${v}`).join('|') 
          : '';
        const uniqueKey = `${item.id}-${propertiesKey}-${index}`;
        
        return <SummaryItem key={uniqueKey} item={item} />;
      })}
    </div>
  );
}; 